import { takeLatest, put, call } from "redux-saga/effects";
import {
  TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_DATA, TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_API,
  TICKET_DASHBOARD_METRICS_TEAM_GET_DATA, TICKET_DASHBOARD_METRICS_TEAM_GET_API,
  TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_DATA, TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_API,
} from "./Constants";
import {
  setTicketDashboardIndividualSuccess, setTicketDashboardIndividualFail,
  setTicketDashboardTeamSuccess, setTicketDashboardTeamFail,
  setTicketDashboardOrganizationSuccess, setTicketDashboardOrganizationFail,
} from "./Actions";
import { addErrorAlert } from "../../../alert/Actions";
import { ticketApi } from "../../../../shared/components/Service";

// Individual
function* getTicketDashboardIndividualService({ request }) {
  try {
    const { period, employeeId } = request;
    const url = employeeId
      ? `${TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_API}?period=${period}&employee_id=${employeeId}`
      : `${TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_API}?period=${period}`;

    const response = yield call(ticketApi.get, url);
    const status = response?.status;
    const apiData = response?.data || response;
    if (status === 200 || apiData?.success) {
      yield put(setTicketDashboardIndividualSuccess(apiData.data));
    } else {
      yield put(addErrorAlert(apiData.msg || "Error fetching individual metrics"));
      yield put(setTicketDashboardIndividualFail(apiData.msg));
    }
  } catch (error) {
    const msg = error?.response?.data?.msg || error?.message || "Error fetching individual metrics";
    yield put(addErrorAlert(msg));
    yield put(setTicketDashboardIndividualFail(msg));
  }
}

// Team
function* getTicketDashboardTeamService({ request }) {
  try {
    const { period, teamId } = request;
    const url = teamId ? `${TICKET_DASHBOARD_METRICS_TEAM_GET_API}?period=${period}&team=${teamId}` : `${TICKET_DASHBOARD_METRICS_TEAM_GET_API}?period=${period}`;  
    const response = yield call(ticketApi.get, url);
    const status = response?.status;
    const apiData = response?.data || response;
    if (status === 200 || apiData?.success) {
      yield put(setTicketDashboardTeamSuccess(apiData.data));
    } else {
      yield put(addErrorAlert(apiData.msg || "Error fetching team metrics"));
      yield put(setTicketDashboardTeamFail(apiData.msg));
    }
  } catch (error) {
    const msg = error?.response?.data?.msg || error?.message || "Error fetching team metrics";
    yield put(addErrorAlert(msg));
    yield put(setTicketDashboardTeamFail(msg));
  }
}

// Organization
function* getTicketDashboardOrganizationService({ request }) {
  try {
    const { period } = request;
    const response = yield call(
      ticketApi.get,
      `${TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_API}?period=${period}`
    );
    const status = response?.status;
    const apiData = response?.data || response;
    if (status === 200 || apiData?.success) {
      yield put(setTicketDashboardOrganizationSuccess(apiData.data));
    } else {
      yield put(addErrorAlert(apiData.msg || "Error fetching organization metrics"));
      yield put(setTicketDashboardOrganizationFail(apiData.msg));
    }
  } catch (error) {
    const msg = error?.response?.data?.msg || error?.message || "Error fetching organization metrics";
    yield put(addErrorAlert(msg));
    yield put(setTicketDashboardOrganizationFail(msg));
  }
}

export function* watchTicketDashboardMetrics() {
  yield takeLatest(TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_DATA.TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_LOAD, getTicketDashboardIndividualService);
  yield takeLatest(TICKET_DASHBOARD_METRICS_TEAM_GET_DATA.TICKET_DASHBOARD_METRICS_TEAM_GET_LOAD, getTicketDashboardTeamService);
  yield takeLatest(TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_DATA.TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_LOAD, getTicketDashboardOrganizationService);
}